export const TAGLINE = 'TAGLINE';
export const LOGO = 'LOGO';
export const BANNER = 'BANNER';
export const SHARE = 'SHARE';
